import { Button } from '@apollo/orbit';
import { FormikComputedProps, FormikHandlers } from 'formik';
import React from 'react';
import { useWizard } from 'react-use-wizard';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

import { AddVariantWizardFields, AddVariantWizardStep } from './shared';

const CancelButton = ({
  onClose,
  className,
  addVariantWizardSteps,
  disabled,
}: {
  onClose: () => void;
  className?: string;
  addVariantWizardSteps: AddVariantWizardStep[];
  disabled: boolean;
}) => {
  const { activeStep } = useWizard();
  return (
    <Button
      isDisabled={disabled}
      variant="secondary"
      data-analytics-label={`button:Cancel,currentStep:${addVariantWizardSteps[activeStep]}`}
      data-analytics-category="Graph Settings Variants"
      onClick={onClose}
      className={className}
    >
      Cancel
    </Button>
  );
};

const BackButton = ({
  className,
  addVariantWizardSteps,
  disabled,
}: {
  className?: string;
  addVariantWizardSteps: AddVariantWizardStep[];
  disabled: boolean;
}) => {
  const { previousStep, activeStep } = useWizard();
  return (
    <Button
      isDisabled={disabled}
      variant="secondary"
      data-analytics-label={`button:Back,currentStep:${addVariantWizardSteps[activeStep]}`}
      data-analytics-category="Graph Settings Variants"
      type="button"
      onClick={previousStep}
      className={className}
    >
      Back
    </Button>
  );
};

const SubmitButton = ({
  isValid,
  handleSubmit,
  isSubmitting,
  subgraphNameAvailable,
  className,
}: {
  isValid: FormikComputedProps<AddVariantWizardFields>['isValid'];
  handleSubmit: FormikHandlers['handleSubmit'];
  isSubmitting: boolean;
  subgraphNameAvailable: boolean;
  className?: string;
}) => {
  return (
    <Button
      className={className}
      isLoading={isSubmitting}
      loadingText="Submitting"
      onClick={() => handleSubmit()}
      isDisabled={!isValid || !subgraphNameAvailable}
      type="submit"
    >
      Add a new variant
    </Button>
  );
};

const ContinueButton = ({
  disabled,
  disabledReason,
}: {
  disabled: boolean;
  disabledReason?: string;
}) => {
  const { nextStep } = useWizard();
  return (
    <Tooltip disabled={!disabled} label={disabledReason} placement="left">
      <span>
        <Button type="submit" isDisabled={disabled} onClick={nextStep}>
          Continue
        </Button>
      </span>
    </Tooltip>
  );
};

export const AddVariantWizardControls = {
  BackButton,
  CancelButton,
  ContinueButton,
  SubmitButton,
};
